const type = {
  not_audit: -1,
  auditing: 0,
  approve: 1,
  not_approve: 2
};

export default type;
